import React from 'react';
import { Spin, Icon } from 'antd';

const TableLoading: React.FC<React.HTMLAttributes<HTMLDivElement>> = (props) => {
    return <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }} {...props}>
        <Spin size="large" indicator={<Icon type="loading" />} />
    </div>
}

export default TableLoading